import { render } from "./OfferDetailsV2.vue?vue&type=template&id=763e9344&scoped=true"
import script from "./OfferDetailsV2.vue?vue&type=script&lang=js"
export * from "./OfferDetailsV2.vue?vue&type=script&lang=js"

import "./OfferDetailsV2.vue?vue&type=style&index=0&id=763e9344&scoped=true&lang=css"
import "./OfferDetailsV2.vue?vue&type=style&index=1&id=763e9344&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763e9344"]])

export default __exports__